<template>
  <form-wrapper :title="option.title"
                :description="option.description"
                @submit="submit()"
                @previous="previous()"
                :isFirst="isFirst"
                :isLast="isLast"></form-wrapper>
</template>

<script>
import { mapActions, mapState } from "vuex";
import formWrapper from "./form-wrapper";

export default {
  data() {
    return {};
  },

  props: {
    option: {
      type: Object,
      required: true
    },
    studentOpportunityAdditionalMaterialId: {
      type: Number,
      required: true
    },
    isFirst: {
      type: Boolean,
      required: false,
      default: false
    },
    isLast: {
      type: Boolean,
      required: false,
      default: false
    }
  },

  components: {
    "form-wrapper": formWrapper
  },

  computed: {
    ...mapState({
      userId: state => state.auth.user.userId
    })
  },
  methods: {
    ...mapActions("placements", ["postSubmit"]),
    handleInput: function() {
      this.returnItem();
    },
    returnItem: function() {
      this.$emit("input", this.form);
    },
    previous: function() {
      this.$emit("previous");
    },
    submit: function() {
      this.postSubmit({
        materialId: this.studentOpportunityAdditionalMaterialId
      }).then(response => {
        if (response) {
          this.$emit("submitted");
        }
      });
    }
  }
};
</script>

<style>
.form-horizontal .control-label {
  padding-bottom: 0;
  font-size: 13px;
}
</style>
